import { jsx as d } from "react/jsx-runtime";
import { buildBrandLogoUrl as l, brandLogoHeightMap as c, defaultBrandLogoUrlConfigOptions as o } from "../../horizon-utils.js";
const u = ({
  brand: t,
  isInverted: e,
  appearance: a = o.appearance,
  extension: i = o.extension,
  size: r = o.size,
  variant: n = o.variant,
  ...g
}) => {
  const s = l({
    appearance: a,
    brand: t,
    extension: i,
    isInverted: e,
    size: r,
    variant: n
  }), [, p] = c[n][r];
  return /* @__PURE__ */ d("img", { style: { height: p }, src: s, ...g });
};
export {
  u as BrandLogo
};
